
import React, { BaseSyntheticEvent } from 'react';
import { observer } from 'mobx-react';
import LayoutFieldsConfigController from '../../../layout-level-fields.controller';
import '../apply-rule-modal.css';
import { CQMasterDataStore } from '../../../../../store/cq-master-data.store';
import { CQAppStore } from '../../../../../store/cq-app-store';
import { Utility } from '../../../../../common/utility';
import { CQAppConstant } from '../../../../../app-constants';
import FieldAndOperator from '../../../../../container/FieldAndOperator/FieldAndOperator';
import { ICriteria, IAction } from '../../ILayoutConfigurationPanel.Interface';

class TransferRuleModalComponent extends React.Component<{
    referenceTo: string,
    selectedFormulaType: string,
    objectName: string,
    appliedRule: any,
    setRuleObject: Function,
    ruleObject: {}, selectedTemplateName: string,
    checkValidation: Function,
    toggleModalVisibility: any
}, any> {
    private readonly layoutFieldsConfigCtrl: LayoutFieldsConfigController;
    private readonly cqUtilityClass: Utility;
    private readonly selectedField: any;
    constructor(props: any) {
        super(props);
        this.layoutFieldsConfigCtrl = new LayoutFieldsConfigController();
        this.cqUtilityClass = new Utility();
        this.selectedField = {...CQMasterDataStore.Details.selectedFieldDetailsObject};
        this.state = {
            setValues: [
                {
                    addedCriterias: [
                        {
                            field: this.selectedField.fullName,
                            operator: '',
                            compareTo: '',
                            isDynamic: false,
                            selectedFieldType: this.selectedField.type,
                            referenceField: '',
                            referenceTo: this.selectedField.referenceTo || '',
                            relationshipName: this.selectedField.relationshipName || ''
                        }
                    ],
                    actionArray: [
                        {
                            selectedLookupValue: '',
                            selectedLayoutField: '',
                            lookupFieldRelationshipName: '',
                            layoutFieldRelationshipName: '',
                        }
                    ],
                    complexLogicQuery: '1',
                    complexLogicVisibility: false,
                    shouldSkip: false
                }
            ],
            additionalFields: [],
            fieldWisePicklistValues: [],
            selectedReferenceFields: [],
            type: this.props.selectedFormulaType,
            lookupFieldsArray: [],
            layoutFieldsArray: [],
        };
    }

    componentDidMount = async () => {
        CQAppStore.loader.setVisibility(true);
        const addedCriteria = this.state.setValues[0].addedCriterias[0];
        this.getReferenceOrPicklistFields(addedCriteria);
        await this.getLookupObjectFields();
        this.setLayoutFields();
        if (this.props.appliedRule) {
            const ruleObject = CQMasterDataStore.RuleElements.FieldRuleElement;
            const objectName: any = this.props.objectName;
            let ruleElement = { ...(ruleObject[objectName])[this.props.appliedRule] };
            if(!ruleElement.setValues){
                const setValues = this.state.setValues ;
                setValues[0].actionArray = [];
                Object.keys(ruleElement).forEach((rule: any) => {
                    setValues[0].actionArray.push(ruleElement[rule]);
                });
                this.setState({
                    setValues
                });
            }else{
                const outputConfigObject = CQMasterDataStore.OutputConfig;
                const selectedObjectName = outputConfigObject.getStoreKeyData(this.props.selectedTemplateName, 'selectedObject');
                if (ruleElement.length !== 0) {
                    let selectedReferenceFields: any[] | undefined = [];
                    let fieldWisePicklistValues = ruleElement.fieldWisePicklistValues;
                    if (ruleElement.selectedReferenceFields) {
                        selectedReferenceFields = await this.layoutFieldsConfigCtrl.getLookFieldsDataInEditMode(ruleElement.selectedReferenceFields);
                        selectedReferenceFields = (selectedReferenceFields && selectedReferenceFields.length > 0) ? selectedReferenceFields : [];
                    }
                    if (fieldWisePicklistValues) {
                        fieldWisePicklistValues = await this.layoutFieldsConfigCtrl.getPickListValueDataInEditMode(selectedObjectName, ruleElement.fieldWisePicklistValues);
                        fieldWisePicklistValues = (fieldWisePicklistValues && fieldWisePicklistValues.length > 0) ? fieldWisePicklistValues : [];
                    }
                    this.setState({
                        setValues: ruleElement.setValues,
                        additionalFields: ruleElement.additionalFields,
                        selectedReferenceFields,
                        fieldWisePicklistValues
                    }, () => {

                    });
                }
            }
        }
        CQAppStore.loader.setVisibility(false);
    }

    public render() {
        const layoutFields = this.layoutFieldsConfigCtrl.getLayoutFields(this.props.selectedTemplateName); 
        return (
            <React.Fragment>
                <div className="slds-grid slds-grid_vertical">
                    {
                        this.state.setValues.map((setValueSection: any, setValueSectionIndex: number) => {
                            return (
                        <>
                                <React.Fragment key={setValueSectionIndex}>
                                    <div className="slds-grid slds-grid_align-spread slds-grid_vertical-align-center slds-m-bottom_small">
                                        <h2>{`Rule ${setValueSectionIndex + 1}`} </h2>
                                        {setValueSectionIndex !== 0 &&
                                            <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                this.setValueRule(setValueSectionIndex);
                                            }}>
                                                <i className="cq-icon-delete"></i>
                                            </button>
                                        }
                                    </div>
                                    <FieldAndOperator 
                                        shouldRender = {setValueSection.shouldSkip} 
                                        values = {setValueSection} 
                                        shouldSkipBtn = {this.shouldSkipBtn} 
                                        setValueSectionIndex = {setValueSectionIndex} 
                                        optionInfo = {{options: layoutFields}}
                                        onFieldChanged = {this.onFieldChangedForRule}
                                        selectedReferenceFields = {this.state.selectedReferenceFields}
                                        renderReferenceFieldsDropDown = {this.renderReferenceFieldsDropDown}
                                        onOperatorChanged = {this.onOperatorChangedForRule}
                                        onCompareToTextChanged = {this.onCompareToTextChanged}
                                        layoutFieldsConfigCtrl = {this.layoutFieldsConfigCtrl}
                                        fieldWisePicklistValues = {this.state.fieldWisePicklistValues}
                                        onCompareFieldChanged = {this.onCompareFieldChanged}
                                        onDynamicFieldsChanged = {this.onDynamicFieldsChanged}
                                        addCriteria = {this.addCriteriaForRule}
                                        deleteCriteria = {this.deleteCriteriaForRule}
                                        onComplexLogicQueryChanged = {this.onComplexLogicQueryChanged}
                                        showComplexLogicInput = {this.showComplexLogicInput}
                                        shouldRenderAddComplexBtn = {true}
                                        shouldDisableFirstElement = {true}
                                        objectName= {this.props.objectName}
                                    />

                                </React.Fragment>
                
                    <div key={`setobject`} className="slds-grid slds-grid_vertical formulaFieldFieldOperatorGrid">
                        <h3 className="slds-m-bottom_small">Set Actions</h3>
                        {
                            setValueSection.actionArray.map((actionSet: any, iterationIndex: number) => {
                                return (
                                    <React.Fragment key={`Action ${iterationIndex}`}>
                                        <div className="slds-grid slds-grid_vertical-align-center slds-gutters_x-small full-width rules-set">
                                            <div className="slds-col col-sm slds-m-bottom_small">{iterationIndex + 1}</div>
                                            <div className="slds-col slds-size_5-of-12">
                                                <div className="slds-form-element">
                                                    <div className="slds-form-element__control">
                                                        <div className="slds-select_container">
                                                            <select role="select-source-field" className="slds-select" id="select-01"
                                                                onChange={e => this.onFieldChanged(e, iterationIndex,setValueSectionIndex)} value={actionSet.selectedLookupValue}>
                                                                <option value="">Select Source Field</option>
                                                                {
                                                                    this.state.lookupFieldsArray.length > 0 && this.state.lookupFieldsArray
                                                                        .map((field: any, index: number) => {
                                                                            return (<option key={index} value={field.name}>{field.label} - {field.name}</option>);
                                                                        })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="slds-col slds-size_5-of-12">
                                                <div className="slds-form-element">
                                                    <div className="slds-form-element__control">
                                                        <div className="slds-select_container">
                                                            <select role="select-target-field" className="slds-select" onChange={e => this.onOperatorChanged(e, iterationIndex,setValueSectionIndex)}
                                                                disabled={!actionSet.selectedLookupValue} value={actionSet.selectedLayoutField}>
                                                                <option value="">Select Target Field</option>
                                                                {
                                                                    this.state.layoutFieldsArray &&
                                                                    this.state.layoutFieldsArray.map((field: any, index: number) => {
                                                                        return (<option key={index} value={field.fieldFullName}>
                                                                            {`${field.fieldLabel} - ${field.fieldFullName}`}</option>);

                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="slds-col slds-size_2-of-12">
                                                <div className="slds-grid slds-m-bottom_xx-small">
                                                    <button role="add-criteria" className="slds-button slds-button_icon slds-button_icon-border-filled slds-m-horizontal_small" onClick={() => {
                                                        this.addCriteria(setValueSectionIndex);
                                                    }}>
                                                        <i className="cq-icon-add"></i>
                                                    </button>
                                                    {
                                                        iterationIndex > 0 && <button className="slds-button slds-button_icon slds-button_icon-border-filled" onClick={() => {
                                                            this.deleteCriteria(setValueSectionIndex, iterationIndex);
                                                        }}>
                                                            <i className="cq-icon-delete"></i>
                                                        </button>
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                );
                            })
                        }
                    </div>
                </>    );
                        })
                    }
                    <div className="slds-grid_absolute-center">
                        <button role="addition-rule" className="slds-button slds-button_neutral slds-m-top_x-small"
                            onClick={this.addSetValueSection}
                        >Add Additional Rule</button>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    /**
     * @private
     * @memberof TransferRuleModalComponent
     */
    private readonly getLookupObjectFields = async () => {
        try {
            const lookupObjectFields = await this.layoutFieldsConfigCtrl.getLookupFields(this.props.referenceTo);
            CQAppStore.loader.setVisibility(false);
            if (lookupObjectFields.fields) {
                this.setState({
                    lookupFieldsArray: lookupObjectFields.fields
                });
            }
        } catch (error : any) {
            this.props.toggleModalVisibility();
            CQAppStore.loader.setVisibility(false);
            const errorObj = {
                errorType: CQAppConstant.ERROR_CUSTOM,
                errorMessage: error.error ? error.error : error.message,
                errorStatus: error.status,
                componentName: ''
            };
            CQAppStore.error.dispatchError(errorObj);
        }
    }

    private getReferenceOrPicklistFields = (addedCriteria: any) => {
        if(addedCriteria.selectedFieldType === CQAppConstant.PICKLIST){
            this.addPickListFieldToState(addedCriteria.field);
        }

        if((CQAppConstant.REFERENCE_FIELD_TYPE).includes(addedCriteria.selectedFieldType)){
            this.setReferenceFieldData(addedCriteria.referenceTo, addedCriteria.field);
        }
    }

    private  shouldSkipBtn = (e :BaseSyntheticEvent, setValueSectionIndex :number,  criteriaIndex ?:number) =>{
        const setValuesClone = JSON.parse(JSON.stringify(this.state.setValues));
        setValuesClone[setValueSectionIndex].addedCriterias= [
                                                        {
                                                            field: this.selectedField.fullName,
                                                            operator: '',
                                                            compareTo: '',
                                                            isDynamic: false,
                                                            selectedFieldType: this.selectedField.type,
                                                            referenceField: '',
                                                            referenceTo: this.selectedField.referenceTo || '',
                                                            relationshipName: this.selectedField.relationshipName || ''
                                                        }
                                                    ];
        setValuesClone[setValueSectionIndex].complexLogicQuery = '1';
        setValuesClone[setValueSectionIndex].complexLogicVisibility = false;
        setValuesClone[setValueSectionIndex].shouldSkip = !setValuesClone[setValueSectionIndex].shouldSkip;
        this.setState({setValues: setValuesClone}, () => ( this.updateRuleObject(this.state) ));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private readonly renderReferenceFieldsDropDown = (criteria: ICriteria, criteriaIndex: number, setValueSectionIndex: number) => {
        const selectedReferenceFields = [...this.state.selectedReferenceFields];
        const referenceFields = selectedReferenceFields.filter((selectedField: any) => {
            return selectedField.fieldName === criteria.field;
        });
        return (
            <>
                {
                    referenceFields.length > 0 &&
                    <div className="slds-form-element">
                        <div className="slds-form-element__control">
                            <div className="slds-form-element__control">
                                <div className="slds-select_container">
                                    <select role="select-reference-field" className="slds-select" id="select-01"
                                        value={criteria.referenceField}
                                        onChange={e => this.onReferenceFieldChanged(e, criteriaIndex, setValueSectionIndex)}
                                    >
                                        <option value="">Select reference field</option>
                                        {
                                            referenceFields[0].relatedFields.map((field: any) =>
                                                <option key={field.name} value={field.name}>{field.name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onReferenceFieldChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        let fieldToBeReplaced = '';
        if(setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField){
            fieldToBeReplaced = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].relationshipName  + '.' + setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField;
        }
        const additionalFieldAction = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField === '' ? CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.ADD : CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.UPDATE;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField = e.target.value;
        const newField = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].relationshipName  + '.' + setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField;
        this.setState({ setValues }, () => {
            this.updateRuleObject(this.state);
            this.updateAdditionalFields(newField, additionalFieldAction, fieldToBeReplaced);
        });
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onFieldChangedForRule = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        let relationField: string = '';
        if((CQAppConstant.REFERENCE_FIELD_TYPE).includes(setValues[setValueSectionIndex].addedCriterias[criteriaIndex].selectedFieldType) &&
            setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField){
                relationField = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].relationshipName  + '.' + setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceField;
                this.updateAdditionalFields(relationField, CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.DELETE);
        }

        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = '';
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].relationshipName = '';
        const selectedField = this.layoutFieldsConfigCtrl.getFieldRelatedMetadata(this.props.selectedTemplateName, e.target.value.split('-')[1] === 'customSettings' ? 'customSettings' : e.target.value);
        if (selectedField.fieldType === CQAppConstant.PICKLIST) {
            this.addPickListFieldToState(e.target.value);
        }
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].selectedFieldType = selectedField.fieldType;

        // If field in the form '<objectApiName>-*', to get only objectApiName
        const replaceFieldName = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].field.split('-')[0];
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].field = e.target.value;
        const additionalFieldAction = replaceFieldName === '' ? CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.ADD : CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.UPDATE;

        if ((CQAppConstant.REFERENCE_FIELD_TYPE).includes(selectedField.fieldType)) {
            setValues[setValueSectionIndex].addedCriterias[criteriaIndex].referenceTo = selectedField.referenceTo;
            setValues[setValueSectionIndex].addedCriterias[criteriaIndex].relationshipName = selectedField.relationshipName;
            this.setReferenceFieldData(selectedField.referenceTo, selectedField.fieldFullName);
        }


        this.setState({ setValues }, () => {
            this.updateRuleObject(this.state);
            
            // If field in the form '<objectApiName>-*', to get only objectApiName
           const field = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].field.split('-')[0];
           this.updateAdditionalFields(field, additionalFieldAction, replaceFieldName);
        });
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private readonly setReferenceFieldData = async (refernceFieldName: string, fieldName: string) => {
        const selectedReferenceFields = [...this.state.selectedReferenceFields];
        const selectedReferenceFieldsCopy = selectedReferenceFields.map((referenceField: any) => {
            return { 'fieldName': referenceField.fieldName, 'refernceFieldName': referenceField.refernceFieldName };
        });
        const hasReferenceFieldDetails = selectedReferenceFields.some((selectedReferenceField: any) => selectedReferenceField.fieldName === fieldName);
        if (!hasReferenceFieldDetails) {
            CQAppStore.loader.setVisibility(true);
            await this.layoutFieldsConfigCtrl.getLookupFields(refernceFieldName).then((lookupFields: any) => {
                if(fieldName === 'customSettings'){
                    lookupFields.fields = lookupFields.fields.filter((field: any) => field.name.includes("__c"));
                    fieldName = this.props.objectName + '-' + fieldName;
                }
                selectedReferenceFieldsCopy.push({ fieldName, refernceFieldName });
                selectedReferenceFields.push({ fieldName, refernceFieldName, relatedFields: lookupFields.fields });
                this.setState({ selectedReferenceFields });
                CQAppStore.loader.setVisibility(false);
            }).catch((error : any) => {
                this.props.toggleModalVisibility();
                CQAppStore.loader.setVisibility(false);
                const errorObj = {
                    errorType: CQAppConstant.ERROR_CUSTOM,
                    errorMessage: error.error ? error.error : error.message,
                    errorStatus: error.status,
                    componentName: ''
                };
                CQAppStore.error.dispatchError(errorObj);
            });
        }
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private readonly addPickListFieldToState = async (pickListFieldFullName: string) => {
        const outputConfigObject = CQMasterDataStore.OutputConfig;
        const objectName = outputConfigObject.getStoreKeyData(this.props.selectedTemplateName, 'selectedObject');

        const fieldWisePicklistValues = [...this.state.fieldWisePicklistValues];
        const isPicklistFieldExist = fieldWisePicklistValues.some((fieldItem: any) => fieldItem.fieldFullName === pickListFieldFullName);
        if (!isPicklistFieldExist) {
            CQAppStore.loader.setVisibility(true);
            const picklistValues = await this.layoutFieldsConfigCtrl.getPicklistValues(objectName, pickListFieldFullName);
            CQAppStore.loader.setVisibility(false);

            if (picklistValues) {
                const picklistField = { fieldFullName: pickListFieldFullName, pickListValues: picklistValues };
                fieldWisePicklistValues.push(picklistField);
                this.setState({ fieldWisePicklistValues });
            }
        }
        return fieldWisePicklistValues;
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onCompareToTextChanged = (compareToValue: string, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = compareToValue;
        this.setState({ setValues }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onOperatorChangedForRule = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].operator = e.target.value;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = (setValues[setValueSectionIndex].addedCriterias[criteriaIndex].operator === 'Exists'
            || setValues[setValueSectionIndex].addedCriterias[criteriaIndex].operator === 'IsEmpty')
            ? '' : setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo;

        this.setState({ setValues }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onCompareFieldChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;

        // If field in the form '<objectApiName>-fieldName', to get only objectApiName
        const replaceFieldName = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo.split('-')[0];
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo = e.target.value;
        const additionalFieldAction = replaceFieldName === '' ? CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.ADD : CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.UPDATE;
        this.setState({ setValues }, () => {
            this.updateRuleObject(this.state);

            // If field in the form '<objectApiName>-fieldName', to get only objectApiName      
            const fieldName = setValues[setValueSectionIndex].addedCriterias[criteriaIndex].compareTo.split('-')[0];
            this.updateAdditionalFields(fieldName, additionalFieldAction, replaceFieldName);
        });
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onDynamicFieldsChanged = (e: BaseSyntheticEvent, criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].addedCriterias[criteriaIndex].isDynamic = e.target.checked;
        this.setState({ setValues }, () => this.updateRuleObject(this.state));

    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onComplexLogicQueryChanged = (e: BaseSyntheticEvent, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].complexLogicQuery = e.target.value;
        this.setState({ setValues }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private showComplexLogicInput = (setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        setValues[setValueSectionIndex].complexLogicVisibility = true;
        this.setState(setValues);
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private readonly addSetValueSection = () => {
        const setValueSection = {
            addedCriterias: [
                {
                    field: this.selectedField.fullName,
                    operator: '',
                    compareTo: '',
                    isDynamic: false,
                    selectedFieldType: this.selectedField.type,
                    referenceField: '',
                    referenceTo: this.selectedField.referenceTo || '',
                    relationshipName: this.selectedField.relationshipName || ''
                }
            ],
            actionArray: [
                {
                    selectedLookupValue: '',
                    selectedLayoutField: '',
                    lookupFieldRelationshipName: '',
                    layoutFieldRelationshipName: '',
                }
            ],
            complexLogicQuery: '1',
            shouldSkip: false
        };
        const setValues = [...this.state.setValues];
        setValues.push(setValueSection);
        this.setState({ setValues }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private readonly updateAdditionalFields = (newFieldName: string, action: string, replaceFieldName?: string) => {
        const additionalFields = [...this.state.additionalFields];
        const layout = CQMasterDataStore.OutputConfig.getTemplateLayoutMetadata(this.props.selectedTemplateName);
        const isAdditionalFieldExist = layout.fields.some((layoutField: string) => layoutField === newFieldName);

        if (action === CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.ADD && !isAdditionalFieldExist) {
            additionalFields.push(newFieldName);
        } else if (action === CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.DELETE) {
            const deleteItemIndex = additionalFields.indexOf(newFieldName);
            if (deleteItemIndex > -1) {
                additionalFields.splice(deleteItemIndex, 1);
            }
        } else if (action === CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.UPDATE && replaceFieldName) {
            const updateItemIndex = additionalFields.indexOf(replaceFieldName);
            if (updateItemIndex > -1) {
                additionalFields.splice(updateItemIndex, 1);
            }
            if (!isAdditionalFieldExist) {
                additionalFields.push(newFieldName);
            }
        }
        this.setState({ additionalFields }, () => {
            this.updateRuleObject(this.state);
        });
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private setValueRule = (setValueSectionIndex: number) => {
        let setValues = this.state.setValues;
        const updatedAdditionalFields = this.removeAllAdditionalFields(setValueSectionIndex);
        setValues = setValues.filter((setValueSection: any, index: number) => index !== setValueSectionIndex);
        this.setState({ setValues, additionalFields: updatedAdditionalFields }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private readonly removeAllAdditionalFields = (setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        let additionalFields = [...this.state.additionalFields];
        const fields = setValues[setValueSectionIndex].addedCriterias.map((criteria: any) => criteria.field);
        fields.forEach((fieldName: string) => {
            additionalFields = additionalFields.filter((additionalField: string) => additionalField !== fieldName);
        });
        return additionalFields;
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private setLayoutFields = () => {
        const layoutFields = this.layoutFieldsConfigCtrl.getLayoutFields(this.props.selectedTemplateName);
        this.setState({
            layoutFieldsArray: layoutFields
        });
    }

    /**
    * @private
    * @memberof ToggleActionsRulesModalComponent
    */
    private onFieldChanged = (e: BaseSyntheticEvent, iterationIndex: number, setValueSectionIndex:number) => {
        const setValues = this.state.setValues;
        let actionArray = setValues[setValueSectionIndex].actionArray;
        
        const selectedLookupValue = e.target.value;
        const selectedLookupField: any = this.state.lookupFieldsArray.filter((lookField: any) => lookField.name === e.target.value);
        setValues[setValueSectionIndex].actionArray[iterationIndex].selectedLookupValue = selectedLookupValue;
        setValues[setValueSectionIndex].actionArray[iterationIndex].selectedLayoutField = '';
        setValues[setValueSectionIndex].actionArray[iterationIndex].lookupFieldRelationshipName = '';
        setValues[setValueSectionIndex].actionArray[iterationIndex].layoutFieldRelationshipName = '';
        
        if (selectedLookupField.length !== 0 && selectedLookupField[0].type === 'reference') {
            setValues[setValueSectionIndex].actionArray[iterationIndex].lookupFieldRelationshipName = selectedLookupField[0].relationshipName;
            setValues[setValueSectionIndex].actionArray[iterationIndex].layoutFieldRelationshipName = '';
        }
        this.setState({
            setValues
        }, () => this.updateRuleObject(this.state));

    }


    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private onOperatorChanged = (e: BaseSyntheticEvent, iterationIndex: number, setValueSectionIndex:number) => {
        const selecetdLayoutField = e.target.value;
        let setValues = this.state.setValues;
        let actionArray = setValues[setValueSectionIndex].actionArray;
        let actionSet = { ...actionArray[iterationIndex] };
        actionSet.selectedLayoutField = selecetdLayoutField;
        const selecetdLayoutFieldRelationshipName = this.state.layoutFieldsArray.filter((layoutField: any) => layoutField.fieldFullName === selecetdLayoutField);
        actionSet.layoutFieldRelationshipName = selecetdLayoutFieldRelationshipName[0].relationshipName;

        setValues[setValueSectionIndex].actionArray[iterationIndex] = actionSet;
        this.setState({
            setValues
        }, () => this.updateRuleObject(this.state));

    }


    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private addCriteria = (setValueSectionIndex:number) => {
        let setValues = this.state.setValues;
        const actionArray = setValues[setValueSectionIndex].actionArray;
        const actionSet = {
            selectedLookupValue: '',
            selectedLayoutField: '',
            lookupFieldRelationshipName: '',
            layoutFieldRelationshipName: '',
        };
        setValues[setValueSectionIndex].actionArray.push(actionSet);
        this.setState({
            setValues
        }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private addCriteriaForRule = (setValueSectionIndex: number) => {
        const critetia = {
            field: '',
            operator: '',
            compareTo: '',
            isDynamic: false,
            selectedFieldType: '',
            referenceField: '',
            referenceTo: '',
            relationshipName: ''
        };
        const setValues = [...this.state.setValues];
        setValues[setValueSectionIndex].addedCriterias.push(critetia);
        let complexLogicQuery = '';
        setValues[setValueSectionIndex].addedCriterias.forEach((critetia: any, index: number) => {
            complexLogicQuery = `${complexLogicQuery}${(setValues[setValueSectionIndex].addedCriterias.length - 1 === index) ? `${index + 1}` : `${index + 1} ${CQAppConstant.AND_OPERATOR} `}`;
        });
        setValues[setValueSectionIndex].complexLogicQuery = complexLogicQuery;

        this.setState({ setValues }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private deleteCriteriaForRule = (criteriaIndex: number, setValueSectionIndex: number) => {
        const setValues = this.state.setValues;
        let addedCriterias = setValues[setValueSectionIndex].addedCriterias;
        this.updateAdditionalFields(addedCriterias[criteriaIndex].field, CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.DELETE);
        if (addedCriterias[criteriaIndex].isDynamic) {
            this.updateAdditionalFields(addedCriterias[criteriaIndex].compareTo, CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.DELETE);
        }

        if((CQAppConstant.REFERENCE_FIELD_TYPE).includes(addedCriterias[criteriaIndex].selectedFieldType)){
            //removing reference field with <objectApiName>.<field>
            const referenceValue = addedCriterias[criteriaIndex].relationshipName + '.' + addedCriterias[criteriaIndex].referenceField;
            this.updateAdditionalFields(referenceValue, CQAppConstant.ADDITIONAL_FIELDS_ACTIONS.DELETE);
        }
        
        addedCriterias = addedCriterias.filter((criteria: any, index: number) => index !== criteriaIndex);
        setValues[setValueSectionIndex].addedCriterias = addedCriterias;
        let complexLogicQuery = '';
        setValues[setValueSectionIndex].addedCriterias.forEach((critetia: any, index: number) => {
            complexLogicQuery = `${complexLogicQuery}${(setValues[setValueSectionIndex].addedCriterias.length - 1 === index) ? `${index + 1}` : `${index + 1} ${CQAppConstant.AND_OPERATOR} `}`;
        });
        setValues[setValueSectionIndex].complexLogicQuery = complexLogicQuery;
        this.setState({ setValues }, () => this.updateRuleObject(this.state));
    }


    /**
    * @private
    * @memberof TransferRuleModalComponent
    */
    private deleteCriteria = (setValueSectionIndex:number, interationIndex: number) => {
        const setValues = this.state.setValues;
        const actionArray = setValues[setValueSectionIndex].actionArray;
        setValues[setValueSectionIndex].actionArray.splice(interationIndex, 1);
        this.setState({
            setValues
        }, () => this.updateRuleObject(this.state));
    }

    /**
    * @private
    * @memberof ToggleActionsRulesModalComponent
    */
    private updateRuleObject = (ruleObjectValue: any) => {
        this.props.setRuleObject(ruleObjectValue);
        this.props.checkValidation(this.validateAddRuleForm());
    }


    /**
    * @private
    * @memberof ToggleActionsRulesModalComponent
    */
    private validateAddRuleForm = () => {
        let isComplexLogicValid = false;
        let isActionsValid = false;
        let isCriteriaValid = false;

        this.state.setValues.forEach((setValueSection: any) => {
            isCriteriaValid = setValueSection.addedCriterias.every((criteria: ICriteria, index: number) => (
                criteria.field !== ''
                && criteria.operator !== ''
                && ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY) ? true : (criteria.compareTo !== ''))
                && ((CQAppConstant.REFERENCE_FIELD_TYPE).includes(criteria.selectedFieldType) ?
                    ((criteria.operator === CQAppConstant.EXISTS || criteria.operator === CQAppConstant.ISEMPTY || index === 0) ? true :
                        (criteria.referenceField !== '')) : true)));

            if(setValueSection.shouldSkip){
                isCriteriaValid = true;
            }

            isActionsValid = setValueSection.actionArray.every((action: any) => (
                action.selectedLookupField !== ''
                && action.selectedLayoutField !== ''));
            isComplexLogicValid = (setValueSection.complexLogicQuery === '');
            return (isCriteriaValid && isActionsValid && isComplexLogicValid);
        });
        if (!isCriteriaValid || !isActionsValid || isComplexLogicValid) {
            return true;
        }
        return false;

    }



}
export const TransferRuleModal = observer(TransferRuleModalComponent);
